import { Stack, useRouter } from 'expo-router';
import { ScrollView } from 'react-native';
import Animated, { FadeInUp } from 'react-native-reanimated';
import { StyleSheet } from 'react-native-unistyles';
import Box from '@/components/Unistyles/Box';
import Text from '@/components/Unistyles/Text';
import { WelcomePrimaryAction } from '@/components/Welcome/WelcomeUI';

const ANIMATION_DURATION_MS = 500;

export default function WelcomeHome() {
  const { navigate } = useRouter();

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <Box flex style={styles.screen}>
        <ScrollView contentContainerStyle={styles.scrollContent}>
          <Box style={styles.content} space="3xl">
            <Animated.View entering={FadeInUp.duration(ANIMATION_DURATION_MS)}>
              <Box center space="lg">
                <Box space="xs">
                  <Text size="4xl" bold center>
                    Welcome to{'\n'}1Time Sports
                  </Text>
                </Box>
              </Box>
            </Animated.View>

            <Animated.View
              entering={FadeInUp.delay(150).duration(ANIMATION_DURATION_MS)}
            >
              <Box center>
                <WelcomePrimaryAction
                  onPress={() => navigate('/welcome/profile')}
                  label="Get Started"
                />
              </Box>
            </Animated.View>
          </Box>
        </ScrollView>
      </Box>
    </>
  );
}

const styles = StyleSheet.create((theme) => ({
  content: {
    alignSelf: 'center',
    maxWidth: theme.size(120),
    paddingVertical: theme.space('3xl'),
    width: '100%',
  },
  scrollContent: {
    flexGrow: 1,
    justifyContent: 'center',
    paddingHorizontal: {
      base: theme.space('lg'),
      md: theme.space('4xl'),
    },
  },
  screen: {
    backgroundColor: theme.colors.background,
  },
}));
